import { createSlice } from "@reduxjs/toolkit";
import { FilterEvidenceRegister } from "./types";

const INITIAL_STATE: FilterEvidenceRegister = {
  filters: {
    search: "",
    meta: {
      page: 1,
    },
  },
};

const evidenceRegisterFilterSlice = createSlice({
  name: "EvidenceRegisterFilter",
  initialState: INITIAL_STATE,
  reducers: {
    setFilter(state, action) {
      state.filters[action.payload.key] = action.payload.value;
    },
  },
});

export const { setFilter } =
  evidenceRegisterFilterSlice.actions;
export default evidenceRegisterFilterSlice.reducer;
